module.exports = __webpack_public_path__ + "static/media/parametry.ba61f83d.svg";